import types from './types';

/**
 * Type defs
 *
 * @typedef TimeOffRequest
 *
 * @property {Number} id
 * @property {Boolean} allDay
 * @property {String} createdAt
 * @property {String} description
 * @property {Number} employeeId
 * @property {String} start
 * @property {String} end
 */

const fetchScheduleRequest = (start, end) => ({
  type: types.FETCH_EMPLOYEE_SHIFTS_REQUEST,
  start,
  end
});

const fetchScheduleSuccess = (shifts, timeOff) => ({
  type: types.FETCH_EMPLOYEE_SHIFTS_SUCCESS,
  shifts,
  timeOff
});

const fetchScheduleFailure = () => ({
  type: types.FETCH_EMPLOYEE_SHIFTS_FAILURE
});

/**
 * Make time off request
 * @param {String} requestType - type of request (partialDay or allDay)
 * @param {String} timeOffType - time off type (pto or unpaid)
 * @param {String} start - start time of request
 * @param {String} end - end time of request
 * @param {String} [description] - description (optional)
 */
const requestTimeOff = (
  requestType,
  timeOffType,
  start,
  end,
  description
) => ({
  type: types.REQUEST_TIME_OFF_REQUEST,
  requestType,
  timeOffType,
  start,
  end,
  description
});

/**
 * Successfully requested time off
 * @param {TimeOffRequest} timeOffRequest
 */
const requestTimeOffSuccess = (timeOffRequest) => ({
  type: types.REQUEST_TIME_OFF_SUCCESS,
  timeOffRequest
});

const requestTimeOffFaliure = error => ({
  type: types.REQUEST_TIME_OFF_FAILURE,
  error
});

export default {
  fetchScheduleRequest,
  fetchScheduleSuccess,
  fetchScheduleFailure,
  requestTimeOff,
  requestTimeOffSuccess,
  requestTimeOffFaliure
};
